"use client"
import { FaTimesCircle } from "react-icons/fa"

const AccountWarningModal = ({ onClose }) => {
 

  return (
    <div className="account-warning-overlay">
      <div className="account-warning-modal">
        <div className="warning-header">
          <h3>Account Verification in Progress</h3>
          <button className="close-warning-btn" onClick={ onClose }>
            <FaTimesCircle />
          </button>
        </div>
        <div className="warning-content">
          <p>Your account is being verified. You can continue with the order process, but please note:</p>
          <ul>
            <li>Account details may not be available yet</li>
            <li>Order processing might be delayed until verification is complete</li>
            <li>You will be notified once verification is complete</li>
            <li>The popup will automatically disappear when account details become available</li>
          </ul>
          <p>If this takes too long, you can come back later or contact support for assistance.</p>
        </div>
        <div className="warning-actions">
          <button className="continue-anyway-btn" onClick={ onClose }>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default AccountWarningModal
